export const publicURL = process.env.PUBLIC_URL ? process.env.PUBLIC_URL: 'sgu_web';